import React from "react";
import {useTranslation} from "react-i18next";
import {WizardStepDef} from "../helpers/onboardingModules";

interface Props {
    steps: WizardStepDef[];
    currentIndex: number;
    terminal?: "success" | "error" | null;
}

/**
 * Compact named stepper for SetupV2 wizard.
 */
const WizardStepper: React.FC<Props> = ({steps, currentIndex, terminal}) => {
    const {t} = useTranslation();

    if (!steps.length) {
        return null;
    }

    return (
        <div className="mb-3">
            <div className="d-flex flex-wrap gap-2 align-items-center">
                {steps.map((step, index) => {
                    const done = terminal === "success" || index < currentIndex;
                    const active = !terminal && index === currentIndex;
                    const failed = terminal === "error" && index === currentIndex;

                    return (
                        <React.Fragment key={step.key}>
                            {index > 0 ? (
                                <span className="text-muted d-none d-md-inline">—</span>
                            ) : null}
                            <span
                                className={[
                                    "badge rounded-pill px-3 py-2",
                                    done ? "bg-success text-white" : "",
                                    active ? "bg-orange-zp text-white" : "",
                                    failed ? "bg-danger text-white" : "",
                                    !done && !active && !failed ? "bg-light text-muted border" : "",
                                ].filter(Boolean).join(" ")}
                            >
                                <span className="me-1">{index + 1}.</span>
                                {t(step.labelKey)}
                            </span>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default React.memo(WizardStepper);
